const article = {
	slug: "managing-ambiguity-self-compassion",
	title: "Be Kind to Yourself: The Takeaway From a Leadership Program",
	date: "24 April 2026",
	updated: null,
	description: "The biggest takeaway from a leadership session on managing ambiguity was an offhand line about self-compassion.",
	keywords: ["leadership", "executive presence", "self-compassion", "career growth"],
	tldr: "High performers are often the hardest on themselves. Leadership starts with giving yourself the same grace you extend to your team.",
	readingTime: null,
	provenance: "Adapted from my LinkedIn post, April 2026.",
	provenanceUrl: null,
	series: null,
	artifact: null,
	markdown: `"Be kind to yourself."

I did not expect that to be the biggest takeaway from a leadership program at PwC last night.

I am part of ASCEND's Leadership Advantage Program, a cohort of leaders from JP Morgan, EY, Deutsche Bank, Bosch, and Brooklyn Sports and Entertainment.

Session 1 was about managing ambiguity. Jane Lauterback of The Purposeworks walked us through a framework for navigating uncertainty in high-stakes environments. Good material. But none of it stayed with me the way that one offhand line did.

We move fast. We hit a milestone and immediately look for the next one. We rarely stop long enough to register what we just did.

High performers are often the hardest on themselves. We hold our teams with patience and give ourselves none of it.

Acknowledge your progress. Treat yourself with the same grace you give the people around you.

Leadership starts there.`,
};

export default article;
